import { useQuery } from '@tanstack/react-query';

export const useFocusedPaymentMethodId = () => {
  return useQuery({
    queryKey: ['focused-payment-method-id'],
    queryFn: () => localStorage.getItem('focused_payment_method_id'),
    staleTime: Infinity,
  });
};
